import { render, staticRenderFns } from "./addressTemplate.vue?vue&type=template&id=4ee96d56&scoped=true"
import script from "./addressTemplate.vue?vue&type=script&lang=js"
export * from "./addressTemplate.vue?vue&type=script&lang=js"
import style0 from "./addressTemplate.vue?vue&type=style&index=0&id=4ee96d56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee96d56",
  null
  
)

export default component.exports